import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import Datepicker from '../../Datepicker/Datepicker';
import { TextField } from '@mui/material';
import { formatDate } from '@/_utils/date';

export interface DatepickerProps {
  showTimeSelect?: boolean;
}

export type DateWidgetProps = DatepickerProps & WidgetProps;

const DateWidget = (props: DateWidgetProps) => {
  const handleChange = (date: any) => {
    props.onChange(date.toISOString());
  };
  if (props.readonly) return <TextField label={props.label} value={props.value?.length ? formatDate(props.value) : undefined} disabled />;
  return (
    <span id={props.id}>
      <Datepicker
        isInsideModal={props.formContext.isInsideModal}
        label={props.label}
        value={props.value?.length ? new Date(props.value) : null}
        onChange={handleChange}
        required={props.required || false}
        showTimeSelect={props.showTimeSelect || false}
        disabled={props.disabled || false}
        error={props.error || false}
      />
    </span>
  );
};

export default DateWidget;
